import { render, staticRenderFns } from "./BaseReportButton.vue?vue&type=template&id=49a2bbd0"
import script from "./BaseReportButton.vue?vue&type=script&lang=ts"
export * from "./BaseReportButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports